import { ChangeEvent, FC, useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useCompetitionFormField } from "shared/hooks/useCompetitionFormField";
import { CompetitionInputComponents } from "./CompetitionInputComponents";
import { ButtonVariant, GridBox } from "@brg/ui";
import { Container, ErrorMessage } from "../style";
import { useTranslation } from "react-i18next";
import { SendButton } from "shared/modals/styles";
import { AppTester } from "supporting";
import { useGetFieldConfig } from "shared/hooks/useGetFieldConfig";
import { CompetitionConsentNames, CompetitionInputNames } from "../types";
import urlApi from "shared/actions/urlApi";
import { CompetitionNewCommonForm } from "./CompetitionNewForm/CompetitionNewCommonForm";

interface FormProps {
  competitionId?: string,
  projectId?: string,
  nominationId?: string,
  isPreRegistration?: boolean,
  shouldSignConsent?: boolean,
  onSubmit: (data: Record<string, any>) => void;
}

const Form: FC<FormProps> = ({ 
    competitionId, 
    projectId, 
    nominationId,
    isPreRegistration, 
    shouldSignConsent, 
    onSubmit 
}) => {
    const { t } = useTranslation();
    const isGeo = AppTester.isGeograffee();
    const [allowedFields, consents] = useCompetitionFormField(competitionId ?? '')
    const {
        config: fieldConfigs, 
        loading: configLoading
    } = useGetFieldConfig(
        competitionId, 
        projectId, 
        nominationId,
        isPreRegistration, 
        shouldSignConsent,
        consents
    )

    const validationSchema = yup.object(
        [...allowedFields, ...consents].reduce((acc, field) => {
            if (!configLoading) {
                if (field in fieldConfigs) {
                    acc[field] = fieldConfigs[field as keyof typeof fieldConfigs].validation;
                }
                return acc;
            }
        return acc
        }, {} as Record<string, yup.AnySchema>)
    );

    const defaultValues = [...allowedFields, ...consents].reduce((acc, field) => {
        const isCheckbox = consents.includes(field as CompetitionConsentNames)
        const isUrl = [CompetitionInputNames.PDF_LINK,CompetitionInputNames.WEB_SITE]?.includes(field as CompetitionInputNames)
        const initValue = isUrl ? null : isCheckbox ? false : ''
        return {
          ...acc,
          [field]: initValue,
        };
      }, {});

    const {
        register,
        control,
        handleSubmit,
        watch,
        formState: { errors, isSubmitting, isSubmitted  },
    } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onTouched',
        defaultValues:defaultValues ,
    });

    // const formObject = watch();
    

    const handleFormSubmit = (data: any) => {
        onSubmit(data);
    };


  return (
    <form noValidate /*onSubmit={handleSubmit(handleFormSubmit)}*/ encType="multipart/form-data" id="submit-form">
      {[...allowedFields, ...consents].map((fieldName: any) => {
        const config = fieldConfigs[fieldName as keyof {}];
        const hidden = !!config?.hidden
        //@ts-ignore
        const shouldShowError = isSubmitted || !!errors[fieldName]?.types?.manual;

        if (!config) return null;

        

        return (
            <GridBox key={fieldName} style={{ ...(!!hidden ? { display: 'none'} : {})}}>
                <CompetitionInputComponents 
                    fieldName={fieldName}
                    inputProps={{
                        id: fieldName,
                        ...config,
                        register: register(fieldName as keyof {}),
                        control
                    }}
                    
                />

                {shouldShowError && errors[fieldName as keyof {}] && (
                    <ErrorMessage>
                        {`— `}{errors[fieldName as keyof typeof errors]?.message as string}
                    </ErrorMessage>
                )}
            </GridBox>   
        )
      })}
        <SendButton
            variant={ButtonVariant.Filled}
            onClick={(ev: React.BaseSyntheticEvent) => {
                ev.preventDefault();
                handleSubmit(handleFormSubmit)()
            }}
        >
            {t('competition.submit_form')}
        </SendButton>
    </form>
  );
};

export const CompetitionCommonForm: FC<{
    competitionId: string,
    projectId: string,
    nominationId: string,
    isPreRegistration?: boolean,
    shouldSignConsent?: boolean,
    renderOldForm?: boolean,
    onSubmit: (data: any) => void,
}> = ({ competitionId, projectId, nominationId, shouldSignConsent, renderOldForm, isPreRegistration, onSubmit }) => {

    //нужно оставить старую форму , потому что много незавершенных конкурсов 
    if (renderOldForm) {
        return <Container>
        <Form 
            competitionId={competitionId} 
            projectId={projectId} 
            isPreRegistration={isPreRegistration}
            nominationId={nominationId} 
            shouldSignConsent={shouldSignConsent}
            onSubmit={onSubmit} 
        />
    </Container>
    }

    return (
        <CompetitionNewCommonForm 
            competitionId={competitionId} 
            projectId={projectId} 
            nominationId={nominationId} 
            isPreRegistration={isPreRegistration} 
            shouldSignConsent={shouldSignConsent} 
            onSubmit={onSubmit} 
        />
    )
}import { ChangeEvent, FC, useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useCompetitionFormField } from "shared/hooks/useCompetitionFormField";
import { CompetitionInputComponents } from "./CompetitionInputComponents";
import { ButtonVariant, GridBox } from "@brg/ui";
import { Container, ErrorMessage } from "../style";
import { useTranslation } from "react-i18next";
import { SendButton } from "shared/modals/styles";
import { AppTester } from "supporting";
import { useGetFieldConfig } from "shared/hooks/useGetFieldConfig";
import { CompetitionConsentNames, CompetitionInputNames } from "../types";
import urlApi from "shared/actions/urlApi";
import { CompetitionNewCommonForm } from "./CompetitionNewForm/CompetitionNewCommonForm";

interface FormProps {
  competitionId?: string,
  projectId?: string,
  nominationId?: string,
  isPreRegistration?: boolean,
  shouldSignConsent?: boolean,
  onSubmit: (data: Record<string, any>) => void;
}

const Form: FC<FormProps> = ({ 
    competitionId, 
    projectId, 
    nominationId,
    isPreRegistration, 
    shouldSignConsent, 
    onSubmit 
}) => {
    const { t } = useTranslation();
    const isGeo = AppTester.isGeograffee();
    const [allowedFields, consents] = useCompetitionFormField(competitionId ?? '')
    const {
        config: fieldConfigs, 
        loading: configLoading
    } = useGetFieldConfig(
        competitionId, 
        projectId, 
        nominationId,
        isPreRegistration, 
        shouldSignConsent,
        consents
    )

    const validationSchema = yup.object(
        [...allowedFields, ...consents].reduce((acc, field) => {
            if (!configLoading) {
                if (field in fieldConfigs) {
                    acc[field] = fieldConfigs[field as keyof typeof fieldConfigs].validation;
                }
                return acc;
            }
        return acc
        }, {} as Record<string, yup.AnySchema>)
    );

    const defaultValues = [...allowedFields, ...consents].reduce((acc, field) => {
        const isCheckbox = consents.includes(field as CompetitionConsentNames)
        const isUrl = [CompetitionInputNames.PDF_LINK,CompetitionInputNames.WEB_SITE]?.includes(field as CompetitionInputNames)
        const initValue = isUrl ? null : isCheckbox ? false : ''
        return {
          ...acc,
          [field]: initValue,
        };
      }, {});

    const {
        register,
        control,
        handleSubmit,
        watch,
        formState: { errors, isSubmitting, isSubmitted  },
    } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onTouched',
        defaultValues:defaultValues ,
    });

    // const formObject = watch();
    

    const handleFormSubmit = (data: any) => {
        onSubmit(data);
    };


  return (
    <form noValidate /*onSubmit={handleSubmit(handleFormSubmit)}*/ encType="multipart/form-data" id="submit-form">
      {[...allowedFields, ...consents].map((fieldName: any) => {
        const config = fieldConfigs[fieldName as keyof {}];
        const hidden = !!config?.hidden
        //@ts-ignore
        const shouldShowError = isSubmitted || !!errors[fieldName]?.types?.manual;

        if (!config) return null;

        

        return (
            <GridBox key={fieldName} style={{ ...(!!hidden ? { display: 'none'} : {})}}>
                <CompetitionInputComponents 
                    fieldName={fieldName}
                    inputProps={{
                        id: fieldName,
                        ...config,
                        register: register(fieldName as keyof {}),
                        control
                    }}
                    
                />

                {shouldShowError && errors[fieldName as keyof {}] && (
                    <ErrorMessage>
                        {`— `}{errors[fieldName as keyof typeof errors]?.message as string}
                    </ErrorMessage>
                )}
            </GridBox>   
        )
      })}
        <SendButton
            variant={ButtonVariant.Filled}
            onClick={(ev: React.BaseSyntheticEvent) => {
                ev.preventDefault();
                handleSubmit(handleFormSubmit)()
            }}
        >
            {t('competition.submit_form')}
        </SendButton>
    </form>
  );
};

export const CompetitionCommonForm: FC<{
    competitionId: string,
    projectId: string,
    nominationId: string,
    isPreRegistration?: boolean,
    shouldSignConsent?: boolean,
    renderOldForm?: boolean,
    onSubmit: (data: any) => void,
}> = ({ competitionId, projectId, nominationId, shouldSignConsent, renderOldForm, isPreRegistration, onSubmit }) => {

    //нужно оставить старую форму , потому что много незавершенных конкурсов 
    if (renderOldForm) {
        return <Container>
        <Form 
            competitionId={competitionId} 
            projectId={projectId} 
            isPreRegistration={isPreRegistration}
            nominationId={nominationId} 
            shouldSignConsent={shouldSignConsent}
            onSubmit={onSubmit} 
        />
    </Container>
    }

    return (
        <CompetitionNewCommonForm 
            competitionId={competitionId} 
            projectId={projectId} 
            nominationId={nominationId} 
            isPreRegistration={isPreRegistration} 
            shouldSignConsent={shouldSignConsent} 
            onSubmit={onSubmit} 
        />
    )
}